import { mapData } from "@/utilities/DataMapping";
import { IVisitReportPathway, VisitReportPathway } from "./VisitReportPathway";

export interface IVisitReportMonth {
    monthName: string;
    count: number;
}

export class VisitReportMonth implements IVisitReportMonth {

    constructor(data?: IVisitReportPathway) {
        if (data) mapData(data, { root: () => this });
    }

    monthName: string = "";
    count: number = 0;
    
}